module.exports = __webpack_public_path__ + "img/mp.fcca6f22.svg";